import { CommonConstants } from './common.constant';

export namespace RouteConstants {
  export enum Route {
    Restaurant = 1,
    AddRestaurant,
    Outlet,
    AddOutlet,
    
    User,
    ApplicationUser,
    BlockedUser,

    Search,

    Diagnostic,
    PaidDiagnostic,
    UnPaidDiagnostic,
    PendingDiagnostic,
    OutletDiagnostic,

    Banner,
    Gallery,

    Masters,
    MasterThirdParty,
    MasterMenuImageTag,

    Assignment,
    Dashboard,

    Notification,
    AppNotification,
    PushNotification,

    Customer,
    MemberCustomer,
    GuestCustomer,
    BlockedCustomer,

    Rewards,

    Menu,
    MenuItem,
    MenuModifier,

    Order,
    Coupon,
    Event,
    Reservation,
    TableOrdering,

    Kiosk,
    KioskList,
    KioskBanner,

    Giftcard,
    Product,
    ProductFee,
    ProductCoupon,
    ProductSell,
    ProductRedeem,
    ProductSearch,

    Catering,
    CateringSetting,
    CateringMenu,

    Reports,
    OrderReports,
    ProductReports,
    MarketingReports,
    MenuReports,
    VisitorReports,

    Setting,
    Profile,
    Hour,
    SpecialHour,
    DeliveryPickup,
    ThirdParty,
    Curbside,
    DeliveryZone,
    Tax,
    Tip,
    Fee,
    ShipDayForm,

    Feature,
    FeatureDetail,
    PaymentMode,
    ShipDay,
    ExternalIntegration,
  }

  export enum ManagerAccess {
    AccessFeature = 1,
    AccessMenu = 2,
    AccessPayment = 3,
    AccessPassword = 4,
    AccessOrder = 5,
  }

  export const RoleLevelAdmin = [
    CommonConstants.Role[CommonConstants.Role.Administrator],
  ];

  export const RoleLevelManager = [
    CommonConstants.Role[CommonConstants.Role.Administrator],
    CommonConstants.Role[CommonConstants.Role.Manager],
  ];

  export const RoleLevelRestaurant = [
    CommonConstants.Role[CommonConstants.Role.Administrator],
    CommonConstants.Role[CommonConstants.Role.Manager],
    CommonConstants.Role[CommonConstants.Role.Restaurant],
  ];

  export const RoleLevelOutlet = [
    CommonConstants.Role[CommonConstants.Role.Administrator],
    CommonConstants.Role[CommonConstants.Role.Manager],
    CommonConstants.Role[CommonConstants.Role.Restaurant],
    CommonConstants.Role[CommonConstants.Role.Outlet],
  ];
}
